import { render } from "./Burger.vue?vue&type=template&id=d0f56e3a&scoped=true"
import script from "./Burger.vue?vue&type=script&lang=js"
export * from "./Burger.vue?vue&type=script&lang=js"

import "./Burger.vue?vue&type=style&index=0&id=d0f56e3a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vizbi-frontend-test/vizbi-frontend-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0f56e3a"]])

export default __exports__